/** 随机生成指定位数的字符串*/
export function randomString(n): string
{
    let str = 'abcdefghijklmnopqrstuvwxyz9876543210';
    let tmp = '', i = 0, l = str.length;
    for (i = 0; i < n; i++)
    {
        tmp += str.charAt(Math.floor(Math.random() * l));
    }
    return tmp;
}

export function formatUrlStringToHump(str: string)
{
    let arr = str.split("-");
    for (let i = 1; i < arr.length; i++)
    {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].substring(1);
    }
    return arr.join("");
}

/** 生成一个随机的颜色便于调试*/
export function generateRandomColor(): string
{
    let str = '#';
    for (var i = 0; i < 6; i++)
    {
        str += Math.floor(Math.random() * 16).toString(16);
    }
    return str;
}

/**随机生成UUID*/
export function generateUUID(): string
{
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++)
    {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    let uuid = s.join("");
    return uuid;
}

/** 递归拷贝对象的所有属性，此方法能够将Proxy代理对象深度（内部嵌套Proxy)还原为普通对象*/
export function copyObject<M>(object: M): M
{
    // 判断是否为object或者array
    if (typeof object != "object" || object == null || object instanceof Date)
    {
        let res: any = object;
        return res;
    }
    // 否则递归拷贝
    let result: any = object instanceof Array ? [] : {};
    for (let key in object)
    {
        result[key] = copyObject(object[key]);
    }
    return result;
}

/**
 * 重置元素，这是最温和的合并并方式
 * 如果to中的数据为undefined，才会把from中的数据拷贝到to中，否则以to中数据为准
 * @param from 拷贝源
 * @param to 拷贝目标
 * @return 合并后的拷贝目标 to
 */
export function supplyObject<T extends object>(from: FreeNecessary<T>, to: T): T
{
    if (typeof to != "object")
    {
        throw new Error("被合并的对象必须为Object对象");
    }
    for (let key in from)
    {
        if (to[key] == undefined)
        {
            to[key] = from[key];
        }
    }
    return to;
}

/**
 * 合并元素，这是比较温和的合并并方式
 * from中不为undefined的数据会被拷贝到to中，否则以to中数据为准
 * @param from 拷贝源
 * @param to 拷贝目标
 * @return 合并后的拷贝目标 to
 */
export function mergeObject<T extends object>(from: FreeNecessary<T>, to: T, defaultValue?: T): T
{
    if (typeof to != "object")
    {
        to = {} as T;
    }
    for (let key in from)
    {
        if (from[key] != undefined)
        {
            to[key] = from[key];
        }
    }
    // 如果有默认值，替换所有的undefined
    if (typeof defaultValue == "object")
    {
        for (let key in defaultValue)
        {
            if (to[key] == undefined)
            {
                to[key] = defaultValue[key];
            }
        }
    }
    return to;
}

/**
 * 重置元素，这是最暴力的合并并方式
 * 会把from中的数据完全拷贝到to中，即使from中数据为undefined，也会进行拷贝
 * @param from 拷贝源
 * @param to 拷贝目标
 * @return 合并后的拷贝目标 to
 */
export function resetObject<T extends object>(from: FreeNecessary<T>, to: T)
{
    if (typeof to != "object")
    {
        to = {} as T;
    }
    if (typeof from == "object")
    {
        for (let key in from)
        {
            to[key] = from[key];
        }
    }
    return to;
}

/** 合并多个JSS对象为一个JSS对象*/
export function mergeJSS<KEY extends string>(...jssArray: JSS<KEY>[]): JSS<KEY>
{
    let result: JSS = {};
    jssArray.map(cur =>
    {
        result = mergeObject(cur, result);
    });
    return result;
}

/** 当页面同时加载2个JSONP标签的时候
 * 浏览器会随机选择某一个标签先执行，造成JS执行乱序问题
 * 所以定义一个同步队列，保证JS的执行顺序按照用户调用的顺序
 */
// const SyncJSLoad = {
//     loadFlag: false,
//     jsTagQue: new Array(),
//     start: () =>
//     {
//         // 正在加载或者队列里没有需要加载的，就不管了
//         if (SyncJSLoad.loadFlag || SyncJSLoad.jsTagQue.length <= 0)
//         {
//             // 如果是正在加载JS，会在onload的时候重新调用此方法
//             return;
//         }
//         // 否则继续按顺序加载
//         SyncJSLoad.loadFlag = true;
//         document.body.appendChild(SyncJSLoad.jsTagQue.shift());
//     }
// };
// // 将类名转为驼峰的函数
// let transName = (str: string) =>
// {
//     str = str.substr(1);
//     let arr = str.split("-");
//     for (let i = 1; i < arr.length; i++)
//     {
//         arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].substring(1);
//     }
//     return arr.join("");
// };
